/* eslint-disable no-unused-expressions */
import React, { useState, useEffect } from "react";
import { system_notification } from "src/store/slice/system";
import "../../../styles/adminconsole.css";
import userphone from "src/assets/images/user-phone-icon.svg";
import useremail from "src/assets/images/user-email-icon.svg";
import usersource from "src/assets/images/user-source-icon.svg";
import usercreated from "src/assets/images/user-create-icon.svg";
import {useUserStore} from "../../../hooks/admin/user";
import store from "src/storeWire";
import {__remove, __set} from "src/store/axios_indicator";
import Helper from "src/support/Helper";
import {useAxiosIndicatorCheck} from "src/store/hook/useAxiosIndicatorCheck";
import useReduxState from "src/hooks/useReduxState";
import System from "src/helper/system";
import {useAdminAccountFilterStore} from "src/hooks/admin/adminAccountFilter";

const UserDetailHeader = (props) => {
  const [__check] = useAxiosIndicatorCheck();
  const [isEdit, setIsEdit] = useReduxState(false, "setIsEdit");
  const [{userDetail}, {get_user_detail}, {update_user_detail, update_user_active_status}] =
    useUserStore();
  const userId = props.userId;
  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    mobileNumber: "",
    telephoneNumber: "",
    isActive: ""
  });
  const [userValidation, setUserValidation] = useState({});
  const [{}, {}, {clear_all_filter}] = useAdminAccountFilterStore();

  useEffect(() => {
    async function fetchHere() {
      __set("USER_DETAIL_API_CALL");
      await get_user_detail(userId);
      setTimeout(() => {
        __remove("USER_DETAIL_API_CALL");
      }, 2000);
    }

    fetchHere();
  }, []);

  const openPopup = () => {
    clear_all_filter()
    store.dispatch(
      system_notification({
        name: "SponsorUserAcct",
        data: {...userDetail, userId,}
      })
    );
  };
  const onEditUser = () => {
    setUser({
      firstName: userDetail.firstName,
      lastName: userDetail.lastName,
      mobileNumber: userDetail.phoneNumber ? userDetail.phoneNumber : "",
      telephoneNumber: userDetail.telephoneNumber
        ? userDetail.telephoneNumber
        : "",
      userId: userDetail.id,
      isActive: userDetail.active
    });
    setUserValidation({});
    setIsEdit(true);
  };

  const onSubmit = async () => {
    const validationModal = {};

    Helper.valueIsNotNull(user.firstName)
      ? ""
      : (validationModal.firstName = "Enter First Name");
    Helper.valueIsNotNull(user.lastName)
      ? ""
      : (validationModal.lastName = "Enter Last Name");
    setUserValidation(validationModal);
    const isValid = Object.keys(validationModal).length > 0 ? false : true;

    if (!Helper.validateDomain(userDetail.emailAddress)) {
      System.clearAllAlert();
      __set("USER_DETAIL_API_CALL");
      const data = {
        isActive: user.isActive,
        id: userId
      }
      setIsEdit(false);
      await update_user_active_status(data)
      await get_user_detail(userId);
      __remove("USER_DETAIL_API_CALL");
    } else {
      if (isValid) {
        System.clearAllAlert();
        __set("USER_DETAIL_API_CALL");
        setIsEdit(false);
        await update_user_detail(user);
        await get_user_detail(userId);
        __remove("USER_DETAIL_API_CALL");
      }
    }
  };

  const onValueChange = (field, value) => {
    if (userValidation && Object.keys(userValidation).length > 0) {
      delete userValidation[field];
    }
    setUser({...user, [field]: value});
  };

  return (
    <>
      {!__check(["USER_DETAIL_API_CALL", "USER_ACCOUNT_API_CALL"]).status && (
        <div className="userdetails bg-gray3">
          <div className="container">
            <div className="user-details-top">
              <div className="user-details-tleft">
                <div className="user-details-name  mb-3">
                  {isEdit && Helper.validateDomain(userDetail.emailAddress) ? (
                    <>
                      <div className="d-flex align-items-center user-contact">
                        <div className="me-3">
                          <label>First Name</label>
                          <input
                            className="ps-2 form-control form-control-sm w200 mb-0"
                            placeholder="First Name"
                            type="text"
                            value={user.firstName}
                            onChange={({target: {value}}) =>
                              onValueChange("firstName", value)
                            }
                          />
                          {userValidation.firstName && (
                            <p className="error"> {userValidation.firstName}</p>
                          )}
                        </div>
                        <div>
                          <label>Last Name</label>
                          <input
                            className="ps-2 form-control form-control-sm w200 mb-0"
                            placeholder="Last Name"
                            type="text"
                            value={user.lastName}
                            onChange={({target: {value}}) =>
                              onValueChange("lastName", value)
                            }
                          />
                          {userValidation.lastName && (
                            <p className="error"> {userValidation.lastName}</p>
                          )}
                        </div>
                      </div>
                    </>
                  ) : (
                    <h4 className="mt-0">
                      {userDetail.firstName} {userDetail.lastName}{" "}
                    </h4>
                  )}
                </div>

                <p className="text-black-stone d-flex align-items-center">
                  <span>
                    Updated on:{" "}
                    {userDetail.updatedDate
                      ? Helper.getDatepickerFormatAdminConsole(userDetail.updatedDate)
                      : ""}{" "}
                  </span>
                  <span className="px-2"> | </span>{" "}
                  <span className="pe-2 d-flex align-items-center">
                    Status:
                    {isEdit ? (
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={user.isActive}
                          onClick={(e) =>
                            onValueChange("isActive", e.target.checked)
                          }
                        />
                        <span className="slider round"></span>
                      </label>
                    ) : (
                      userDetail.active ? "Active" : "Inactive"
                    )}
                  </span>
                </p>
              </div>
              <div className="user-details-tright">
                {isEdit ? (
                  <>
                    <div className="mb-3">
                      <button
                        className="bs5 btn btn-secondary me-3"
                        onClick={() => setIsEdit(false)}
                      >
                        cancel
                      </button>
                      <button
                        className="bs5 btn btn-primary w200 "
                        onClick={() => {
                          onSubmit();
                        }}
                      >
                        save
                      </button>
                    </div>
                    {/* <div>
                      <button className="bs5 btn btn-secondary w200" disabled>
                        SPONSOR TO AN ACCOUNT
                      </button>
                    </div> */}
                  </>
                ) : (
                  <>
                    {!(userDetail.source === "SAP") && (
                      <div className="mb-3">
                        <button
                          className="bs5 btn btn-secondary w200"
                          onClick={() => onEditUser()}
                        >
                          Edit
                        </button>
                      </div>
                    )}
                  </>
                )}
                {userDetail.source !== "SAP" &&
                  <div>
                    <button
                      className="bs5 btn btn-secondary w200"
                      onClick={() => openPopup()}
                      disabled={userDetail.source === "SAP"}
                    >
                      SPONSOR TO AN ACCOUNT
                    </button>
                  </div>
                }
              </div>
            </div>
          </div>
          <div className="user-details-bottom">
            <ul>
              <li>
                <div className="container">
                  <div className="user-details-bottom-left">
                    <i>
                      <img src={userphone} className="me-2"/>
                    </i>
                    {isEdit &&
                    Helper.validateDomain(userDetail.emailAddress) ? (
                      <div className="d-flex align-items-center user-contact">
                        <div className="me-3">
                          <label>Mobile</label>
                          <input
                            className="ps-2 form-control form-control-sm w200 mb-0"
                            placeholder="Mobile"
                            type="text"
                            value={user.mobileNumber}
                            onChange={({target: {value}}) =>
                              onValueChange("mobileNumber", value)
                            }
                          />
                        </div>
                        <div>
                          <label>Telephone</label>
                          <input
                            className="ps-2 form-control form-control-sm w200 mb-0"
                            placeholder="Teletphone"
                            type="text"
                            value={user.telephoneNumber}
                            onChange={({target: {value}}) =>
                              onValueChange("telephoneNumber", value)
                            }
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="d-flex align-items-center">
                        <p className="mb-0 text-black-stone">
                          {" "}
                          M: {userDetail.phoneNumber}
                        </p>{" "}
                        <span className="px-3"> |</span>
                        <p className="mb-0 text-black-stone">
                          {" "}
                          T: {userDetail.telephoneNumber}
                        </p>
                      </div>
                    )}
                  </div>
                  <div className="text-black-stone user-details-bottom-right">
                    <i>
                      <img src={useremail} className="me-2"/>
                    </i>{" "}
                    <p className="mb-0 text-black-stone">
                      {" "}
                      {userDetail.emailAddress}
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div className="container">
                  <div className="text-black-stone user-details-bottom-left">
                    <i>
                      <img src={usersource} className="me-2"/>
                    </i>{" "}
                    <p className="mb-0 text-black-stone">
                      {" "}
                      Source: {userDetail.source}
                    </p>
                  </div>
                  <div className="text-black-stone user-details-bottom-right">
                    <i>
                      <img src={usercreated} className="me-2"/>
                    </i>{" "}
                    <p className="mb-0 text-black-stone">
                      Created on:{" "}
                      {userDetail.createDate
                        ? Helper.getDatepickerFormatAdminConsole(userDetail.createDate)
                        : ""}{" "}
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      )}
    </>
  );
};

export default UserDetailHeader;
